import { z } from 'zod';
export const PASSWORD_MIN_LENGTH = 12;
export const passwordSchema = z
    .string()
    .min(PASSWORD_MIN_LENGTH, `Fjalëkalimi duhet të ketë të paktën ${PASSWORD_MIN_LENGTH} shkronja ose shifra.`)
    .max(128);
export const loginSchema = z.object({
    email: z.string().trim().toLowerCase().email('Adresa e emailit nuk duket e saktë.'),
    password: z.string().min(1, 'Shkruani fjalëkalimin.').max(256),
});
export const verifyOtpSchema = z.object({
    challengeId: z.string().uuid(),
    code: z.string().regex(/^\d{6}$/, 'Kodi ka 6 shifra.'),
    /** Skip the e-mailed code on this browser for the configured number of days. */
    rememberDevice: z.boolean().default(false),
});
export const forgotPasswordSchema = z.object({
    email: z.string().trim().toLowerCase().email('Adresa e emailit nuk duket e saktë.'),
});
export const resetPasswordSchema = z.object({
    token: z.string().min(32),
    password: passwordSchema,
});
export const changePasswordSchema = z.object({
    currentPassword: z.string().min(1),
    newPassword: passwordSchema,
});
//# sourceMappingURL=auth.js.map